(() => {
  const priceSelector = '.nuvio-variant-collection .nv-vc-price span';
  const documentLinkSelector = [
    'body.template-product .product-short-description a',
    'body.template-product .accordion__content a',
    'body.template-product .product-information--inner a'
  ].join(',');

  const cleanPrices = (root = document) => {
    const elements = [];

    if (root.nodeType === 1 && root.matches?.(priceSelector)) {
      elements.push(root);
    }

    root.querySelectorAll?.(priceSelector).forEach((element) => elements.push(element));

    elements.forEach((element) => {
      element.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && /^\s*From\s+/i.test(node.nodeValue || '')) {
          node.nodeValue = node.nodeValue.replace(/^\s*From\s+/i, '');
        }
      });
    });
  };

  const documentContext = (link) => {
    const nearby = link.closest('p, li');
    return [
      link.textContent || '',
      link.getAttribute('href') || '',
      link.getAttribute('title') || '',
      link.getAttribute('aria-label') || '',
      nearby?.textContent || ''
    ]
      .join(' ')
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  const isProductDocumentLink = (link) => {
    const context = documentContext(link);
    return /\b(specification(?:\s+(?:sheet|document))?|spec\s*sheet|warr(?:a|e)nty)\b/i.test(context);
  };

  const styleDocumentLinks = (root = document) => {
    const links = [];

    if (root.nodeType === 1 && root.matches?.(documentLinkSelector)) {
      links.push(root);
    }

    root.querySelectorAll?.(documentLinkSelector).forEach((link) => links.push(link));

    links.forEach((link) => {
      if (!isProductDocumentLink(link)) return;
      link.classList.add('nuvio-document-button');

      const row = link.closest('p, li');
      if (row) {
        row.classList.add('nuvio-document-row');
        Array.from(row.childNodes).forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && /^[\s.·•]+$/.test(node.nodeValue || '')) {
            node.remove();
          }
        });
      }
    });

    const productScopes = root.querySelectorAll?.(
      'body.template-product .product-short-description, body.template-product .accordion__content, body.template-product .product-information--inner'
    ) || [];

    productScopes.forEach((scope) => {
      scope.querySelectorAll('p').forEach((paragraph) => {
        if (!/^[\s.·•]+$/.test(paragraph.textContent || '')) return;
        const previousHasDocument = paragraph.previousElementSibling?.querySelector?.('.nuvio-document-button')
          || paragraph.previousElementSibling?.matches?.('.nuvio-document-row');
        const nextHasDocument = paragraph.nextElementSibling?.querySelector?.('.nuvio-document-button')
          || paragraph.nextElementSibling?.matches?.('.nuvio-document-row');
        if (previousHasDocument || nextHasDocument) paragraph.remove();
      });
    });
  };

  const enhance = (root = document) => {
    cleanPrices(root);
    styleDocumentLinks(root);
  };

  const start = () => {
    enhance(document);

    if (!document.body || !window.MutationObserver) return;

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) enhance(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
